export const SYNC_GEOFENCE_USERS = '@@geofences/syncGeofenceUsers'

export const UPDATE_GEOFENCE_USERS = '@@geofences/updateGeofenceUsers'
